import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from './Navbar';
import IosInstallPrompt from '../pwa/IosInstallPrompt';
import UserSupportChatWidget from '../ui/UserSupportChatWidget';
import { useAuth } from '../../hooks/useAuth';
import { PLAY_STORE_URL } from '../../constants';
import { ROUTES } from '../../constants/routes';
import transparentLogo from '../../assets/images/Transparent_logo.png';

const AppLayout = () => {
  const { user } = useAuth();

  return (
    <div className="app-layout">
      <Navbar />
      <main className="page-content">
        <Outlet />
      </main>

      {/* iOS PWA Install Banner */}
      <IosInstallPrompt />

      {/* Live Floating Support Chat Widget */}
      <UserSupportChatWidget />

      {/* Modern Responsive Footer */}
      <footer className="app-footer">
        <div className="footer-container">
          <div className="footer-brand-col">
            <div className="footer-logo">
              <img src={transparentLogo} alt="Bible Contest Logo" className="footer-logo-img" />
              <span>Bible Contest</span>
            </div>
            <p className="footer-tagline">
              Building daily Scripture reading habits through joyful trivia challenges, helping believers walk in truth and discern false teachings.
            </p>
            <div className="footer-play-btn-wrap">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-play-store-sm"
              >
                <svg className="play-store-svg" viewBox="0 0 24 24" width="18" height="18">
                  <path fill="#4285F4" d="M3.61 2.39L13.84 12.62 3.61 22.85c-.41-.33-.61-.84-.61-1.44V3.83c0-.6.2-1.11.61-1.44z"/>
                  <path fill="#FBBC04" d="M17.47 8.99l-3.63 3.63L3.61 2.39c.27-.22.61-.39 1.01-.39.52 0 1.03.17 1.48.42l11.37 6.57z"/>
                  <path fill="#34A853" d="M17.47 16.25L6.1 22.82c-.45.26-.96.42-1.48.42-.4 0-.74-.17-1.01-.39l10.23-10.23 3.63 3.63z"/>
                  <path fill="#EA4335" d="M21.6 13.84l-4.13 2.41-3.63-3.63 3.63-3.63 4.13 2.41c.88.51.88 1.93 0 2.44z"/>
                </svg>
                <span>Get it on Google Play</span>
              </a>
            </div>
          </div>

          <div className="footer-links-col">
            <h4>Explore</h4>
            <ul>
              {user && <li><Link to={ROUTES.GAMES.PLAY}>Play Games</Link></li>}
              {user && <li><Link to={ROUTES.GAMES.GLOBAL_LEADERBOARD}>Global Leaderboard</Link></li>}
              <li><Link to={ROUTES.PUBLIC.HOME}>About Bible Contest</Link></li>
              <li><Link to={ROUTES.PUBLIC.VOLUNTEER}>Volunteer & Careers</Link></li>
              <li><Link to={ROUTES.PUBLIC.DONATE}>Partner with Us</Link></li>
              <li><Link to={ROUTES.PUBLIC.BLOG}>Biblical Insights Blog</Link></li>
            </ul>
          </div>

          <div className="footer-links-col">
            <h4>Community & Host</h4>
            <ul>
              {user && <li><Link to={ROUTES.PUBLIC.STUDIO}>Host Studio & Quizzes</Link></li>}
              <li><Link to={ROUTES.PUBLIC.SUPPORT}>Support & FAQs</Link></li>
              <li><Link to={ROUTES.LEGAL.PRIVACY}>Privacy Policy</Link></li>
              <li><Link to={ROUTES.LEGAL.TERMS}>Terms & Conditions</Link></li>
              <li><Link to={ROUTES.LEGAL.DELETION_REQUEST}>Account Deletion</Link></li>
            </ul>
          </div>

        <div className="footer-links-col">
          <h4>Our Mission</h4>
          <p className="footer-scripture-quote">
            "Your word is a lamp to my feet and a light to my path."
            <br />
            <strong>— Psalm 119:105</strong>
          </p>
          <small style={{ color: 'var(--clr-muted)', marginTop: '8px', display: 'block' }}>
            We use every penny responsibly and accountably to fund cloud servers and student prizes.
          </small>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Bible Contest Ministry. All rights reserved.</span>
        <span>Dedicated to the glory of God and the study of His Word.</span>
      </div>
    </footer>
  </div>
  );
};

export default AppLayout;
